export default __webpack_public_path__ + "static/media/page8Image5.a8992983.jpeg";